import { render, staticRenderFns } from "./ApprTemp6.vue?vue&type=template&id=8570551c&scoped=true&"
import script from "./ApprTemp6.vue?vue&type=script&lang=js&"
export * from "./ApprTemp6.vue?vue&type=script&lang=js&"
import style0 from "./ApprTemp6.vue?vue&type=style&index=0&id=8570551c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8570551c",
  null
  
)

export default component.exports